let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6ZsM2")).then(() => parcelRequire('boO6G'));